export default "__VITE_ASSET__DNM5NsWi__"